const BulkSelectActionTypes = {
  SELECT_ALL_ITEMS:    'SELECT_ALL_ITEMS',
  DESELECT_ALL_ITEMS:  'DESELECT_ALL_ITEMS',

  SELECT_LEAD_ITEMS:   'SELECT_LEAD_ITEMS',
  DESELECT_LEAD_ITEMS: 'DESELECT_LEAD_ITEMS',

  SELECT_LEAD_ITEM:    'SELECT_LEAD_ITEM',
  DESELECT_LEAD_ITEM:  'DESELECT_LEAD_ITEM',

  SELECT_DOCUMENT_ITEM:   'SELECT_DOCUMENT_ITEM',
  DESELECT_DOCUMENT_ITEM: 'DESELECT_DOCUMENT_ITEM',

  SELECT_DOCUMENT_ITEMS:   'SELECT_DOCUMENT_ITEMS',
  DESELECT_DOCUMENT_ITEMS: 'DESELECT_DOCUMENT_ITEMS',

  SELECT_TRASH_DOCUMENT_ITEM:   'SELECT_TRASH_DOCUMENT_ITEM',
  DESELECT_TRASH_DOCUMENT_ITEM: 'DESELECT_TRASH_DOCUMENT_ITEM',

  SELECT_TRASH_DOCUMENT_ITEMS:   'SELECT_TRASH_DOCUMENT_ITEMS',
  DESELECT_TRASH_DOCUMENT_ITEMS: 'DESELECT_TRASH_DOCUMENT_ITEMS',

  SELECT_VIDEO_ITEM:   'SELECT_VIDEO_ITEM',
  DESELECT_VIDEO_ITEM: 'DESELECT_VIDEO_ITEM',

  SELECT_VIDEO_ITEMS:   'SELECT_VIDEO_ITEMS',
  DESELECT_VIDEO_ITEMS: 'DESELECT_VIDEO_ITEMS',

  SELECT_TRASH_VIDEO_ITEM:   'SELECT_TRASH_VIDEO_ITEM',
  DESELECT_TRASH_VIDEO_ITEM: 'DESELECT_TRASH_VIDEO_ITEM',

  SELECT_TRASH_VIDEO_ITEMS:   'SELECT_TRASH_VIDEO_ITEMS',
  DESELECT_TRASH_VIDEO_ITEMS: 'DESELECT_TRASH_VIDEO_ITEMS',

  SELECT_JOB_ITEM:   'SELECT_JOB_ITEM',
  DESELECT_JOB_ITEM: 'DESELECT_JOB_ITEM',

  SELECT_JOB_ITEMS:   'SELECT_JOB_ITEMS',
  DESELECT_JOB_ITEMS: 'DESELECT_JOB_ITEMS',

  SELECT_CANDIDATE_ITEM:   'SELECT_CANDIDATE_ITEM',
  DESELECT_CANDIDATE_ITEM: 'DESELECT_CANDIDATE_ITEM',

  SELECT_CANDIDATE_ITEMS:   'SELECT_CANDIDATE_ITEMS',
  DESELECT_CANDIDATE_ITEMS: 'DESELECT_CANDIDATE_ITEMS',
};

export default BulkSelectActionTypes;
